import { createContext, useState } from 'react';
import { LoadingContextState, LoadingProviderProps } from '../types/LoadingProviderType';

const DEFAULT_VALUE: LoadingContextState = {
  isLoading: {
    value: false
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsLoading: () => { }
};

export const LoadingContext = createContext<LoadingContextState>(DEFAULT_VALUE);

export const LoadingProvider = ({ children }: LoadingProviderProps) => {
  const [isLoading, setIsLoading] = useState(DEFAULT_VALUE.isLoading);

  return (
    <LoadingContext.Provider
      value={{
        isLoading,
        setIsLoading
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};
